namespace $ {

	export class $shm_hitalama_map_widget_entity_code_sql extends $giper_baza_entity.with({

		Sql: $giper_baza_text,

	}) {

		@ $mol_mem
		sql( next?: string ) {
			return this.Sql(next)?.value(next) ?? ''
		}

	}

}
